/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getDetailDialog, clearDetailDialog, clearNode } = actions;
export default (id) => {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  return useEffect(() => {
    if (authReducer.isLogin && authReducer.sessionId) {
      dispatch(
        getDetailDialog({
          id,
        })
      );
    }
    // Unmount
    return () => {
      dispatch(clearDetailDialog());
      dispatch(clearNode());
    };
  }, [dispatch, authReducer.isLogin]);
};
